import React from "react";
import AboutAreaTwo from "../components/AboutAreaTwo";
import BannerTwo from "../components/BannerTwo";
import FooterTwo from "../components/FooterTwo";
import NavbarTwo from "../components/NavbarTwo";
import WorkProcessTwo from "../components/WorkProcessTwo";
import BrandAreaOne from "../components/BrandAreaOne";
import ServiceAreaOne from "../components/ServiceAreaOne";
import FaqAreaOne from "../components/FaqAreaOne";
import ContactAreaFour from "../components/ContactAreaFour";
import PartnerShipArea from "../components/PartnerShipArea";
import AboutAreaFive from "../components/AboutAreaFive";
import AboutUs from "../components/HnaM3ak/AboutUs";
import ProcessusDePriseEnCharge from "../components/HnaM3ak/ProcessusDePriseEnCharge";
import IntervenantsSection from "../components/HnaM3ak/IntervenantsSection";
import Footer from "../components/HnaM3ak/Footer";

const HomeTwo = () => {
  return (
    <>
      {/* Navigation Bar Two*/}
      <NavbarTwo />
      {/* Banner Two */}
      <BannerTwo />

      {/* <WorkProcessTwo /> */}
      


      {/* About Area Two */}
      {/* <AboutAreaTwo /> */}
      <AboutUs/>


      <ProcessusDePriseEnCharge/>


      

      {/* Service Area One */}
      {/* <ServiceAreaOne /> */}

      {/* FAQ Area One */}
      {/* <FaqAreaOne /> */}

      {/* About Area Two */}
      {/* <ServiceAreaTwo /> */}
      {/* Pricing Area Two */}
      {/* <PricingAreaTwo /> */}

      {/* Counter Area Two */}
      {/* <CounterAreaTwo /> */}

      {/* Contact Area Two */}
      {/* <ContactAreaTwo /> */}

      {/* Work Process Two */}

      {/* <WorkProcessTwo /> */}

      {/* Testimonial One */}
      {/* <TestimonialOne /> */}

      {/* Contact Area Four */}
      <ContactAreaFour />

      {/* <PartnerShipArea /> */}

      {/* Blog Area Two */}
      {/* <BlogAreaTwo /> */}

      <IntervenantsSection/>

      {/* <BrandAreaOne /> */}

      {/* Footer Two */}
      <Footer />
    </>
  );
};

export default HomeTwo;
